<div class="row">
  <div class="col-sm-12">
    <div class="headinghead">
      <div class="heading">
        <h1>Vendors Revenue</h1>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="iq-card">
      <div class="iq-card-header">
        <div class="row py-3">
          <div class="col-sm-3">
            <select #statusOrderBy class="form-control">
              <option value="pastWeek" [selected]="'pastWeek'==statusOrderByinfo">One Week</option>
              <option value="lastMonth" [selected]="'lastMonth'==statusOrderByinfo">One Month</option>
              <option value="lastSixMonths" [selected]="'lastSixMonths'==statusOrderByinfo">Six month</option>
              <option value="lastYear" [selected]="'lastYear'==statusOrderByinfo">One Year</option>
              <option value="allTime" [selected]="'allTime'==statusOrderByinfo">All Time</option>
            </select>
          </div>
          <div class="col-sm-3">
            <button type="button" class="btn btn-theme w-150" (click)="getComboPackage()"><i class="fa fa-search"></i>
              Search</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="SkipDv" *ngIf="tabsArray.length > 1" (click)="backTabs()">
  <svg xmlns="http://www.w3.org/2000/svg" width="7.867" height="4.714" viewBox="0 0 7.867 4.714">
    <g id="icon-arrow-down" transform="translate(20 4.714) rotate(-90)">
      <g id="previous" transform="translate(0 -20)">
        <path id="Path_1686" data-name="Path 1686"
          d="M.222,3.375a.769.769,0,0,1,.129-.1L3.4.223A.762.762,0,0,1,4.478,1.3L1.852,3.927l2.64,2.64A.762.762,0,1,1,3.414,7.644L.351,4.581A.791.791,0,0,1,.222,3.375Z" />
      </g>
    </g>
  </svg>
  <h1>Back</h1>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="iq-card">
      <div class="iq-card-body">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Vendor Image</th>
                <th>Vendor Name</th>
                <th>Vendor Email</th>
                <th>Vendor Profit</th>
                <th>Allout Admin Profit</th>
                <th>Total Bookings</th>
                <th>Total Services</th>
                <th>Total Locations</th>
                <th>Total Customers</th>
                <th>Total Categories</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of allData">
                <td><img class="tbleimg" [src]="item?.vendor?.photoUrl ? item?.vendor?.photoUrl : avtar"></td>
                <td>{{ item.vendor.firstName }} {{ item.vendor.lastName }}</td>
                <td>{{ item.vendor.email }}</td>
                <td>{{ item.stats.totalEarnings.count * 0.8 | number }} AED</td>
                <td>{{ item.stats.totalEarnings.count * 0.2 | number }} AED</td>
                <td>{{ item.stats.totalBookings }}</td>
                <td>{{ item.stats.totalServices }}</td>
                <td>{{ item.stats.totalLocations }}</td>
                <td>{{ item.stats.totalCustomers }}</td>
                <td>{{ item.stats.totalCategories }}</td>
              </tr>
              <tr *ngIf="!allData.length">
                <td colspan="15">
                  <div class="alert alert-danger d-block text-center">We couldn't find your record(s).</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
